import React from 'react';
import { CheckCircle2, Home, Key, Briefcase } from 'lucide-react';
// ============================================
// SECCIÓN 1: APARTAMENTO NUEVO (OP1)
// ============================================
const apartamentoNuevoSection = {
  title: '🔑 Recibiste las llaves de tu apartamento nuevo',
  description: 'Ya pagaste escrituras y ya es tuyo, pero no te puedes mudar. Cada mes que pasa sin acabados, es plata de arriendo que se pierde o tiempo de felicidad que se aplaza.',
  need: 'Lo que necesitas: Un equipo que entre, trabaje rápido y te entregue tu hogar listo para estrenar.',
  ctaText: 'Quiero los acabados para mi apartamento.'
};
// ============================================
// SECCIÓN 2: RENOVAR CASA ACTUAL (OP2)
// ============================================
const renovarCasaSection = {
  title: '🏠 Quieres renovar la casa donde vives',
  description: 'Esa cocina que ya no te gusta o el baño que se ve viejo. Te da miedo empezar porque no quieres vivir meses entre el polvo y el desorden, o que te dejen la obra a medias.',
  need: 'Lo que necesitas: Orden, limpieza y cumplimiento. Nosotros nos encargamos de que el proceso sea lo más cómodo posible para ti.',
  ctaText: 'Quiero remodelar mi casa actual.'
};
// ============================================
// SECCIÓN 3: INMUEBLE PARA ARRENDAR (OP3)
// ============================================
const inmuebleArriendoSection = {
  title: '💰 Tienes un inmueble para arrendar',
  description: 'El inquilino se fue y el apartamento se ve desgastado frente a otros de la zona. Cada mes que sigue vacío es dinero que dejas de recibir.',
  need: 'Lo que necesitas: Una actualización inteligente para subir el valor del arriendo sin gastar de más.',
  ctaText: 'Quiero valorizar mi inmueble para rentar.'
};
export function SituationsSection() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setTimeout(() => {
        const firstInput = document.getElementById('nombre');
        if (firstInput) firstInput.focus();
      }, 500);
    }
  };
  return <section id="situations" className="bg-[#1A1A1A] py-12 md:py-20" style={{
    contentVisibility: 'auto'
  }} data-id="element-335">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-336">
        {/* Main Title */}
        <div className="text-center mb-8 md:mb-16" data-id="element-337">
          <h2 className="text-[26px] md:text-[40px] font-bold text-white" style={{
          lineHeight: '1.2',
          letterSpacing: '-0.02em'
        }} data-id="element-338">
            ¿Cuál de estas es tu situación?
          </h2>
        </div>

        <div className="space-y-12 md:space-y-24" data-id="element-339">
          {/* SECCIÓN 1: Apartamento Nuevo */}
          <div className="max-w-3xl mx-auto space-y-6 md:space-y-8" data-id="element-340">
            <div className="text-center" data-id="element-341">
              <h3 className="text-[20px] md:text-[28px] font-semibold text-white mb-4 md:mb-6" style={{
              lineHeight: '1.3'
            }} data-id="element-342">
                {'\uD83D\uDD11 \xBFEst\xE1s estrenando?'}
              </h3>
            </div>

            <div className="bg-white/5 rounded-3xl p-6 md:p-8 border border-white/10 space-y-6" data-id="element-343">
              <p className="text-[15px] md:text-[17px] text-white/80 font-normal text-center" style={{
              lineHeight: '1.6'
            }} data-id="element-344">
                {'Quieres acabados a tu gusto para que mudarte ya y dejar de pagar arriendo.'}
              </p>
              <div className="bg-[#E8621A]/10 border-2 border-[#E8621A] rounded-2xl p-6" data-id="element-345">
                <p className="text-[15px] md:text-[17px] text-white font-normal text-center md:text-left" style={{
                lineHeight: '1.6'
              }} data-id="element-346">
                  {apartamentoNuevoSection.need}
                </p>
              </div>
            </div>

            <div className="text-center" data-id="element-347">
              <button onClick={scrollToOffer} className="w-full md:w-auto bg-[#E8621A] text-white px-8 md:px-12 py-4 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-all min-h-[52px]" style={{
              lineHeight: '1',
              letterSpacing: '0.08em'
            }} data-id="element-348">
                {apartamentoNuevoSection.ctaText}
              </button>
            </div>
          </div>

          {/* SECCIÓN 2: Renovar Casa Actual */}
          <div className="max-w-3xl mx-auto space-y-6 md:space-y-8" data-id="element-349">
            <div className="text-center" data-id="element-350">
              <h3 className="text-[20px] md:text-[28px] font-semibold text-white mb-4 md:mb-6" style={{
              lineHeight: '1.3'
            }} data-id="element-351">
                {'\uD83C\uDFE0 \xBFQuieres renovar tu hogar?'}
              </h3>
            </div>

            <div className="bg-white/5 rounded-3xl p-6 md:p-8 border border-white/10 space-y-6" data-id="element-352">
              <p className="text-[15px] md:text-[17px] text-white/80 font-normal text-center" style={{
              lineHeight: '1.6'
            }} data-id="element-353">
                {'Quieres remodelar tu cocina o ba\xF1o con orden, limpieza y en tiempo r\xE9cord sin vivir meses entre el polvo y el desorden.'}
              </p>
              <div className="bg-[#E8621A]/10 border-2 border-[#E8621A] rounded-2xl p-6" data-id="element-354">
                <p className="text-[15px] md:text-[17px] text-white font-normal whitespace-pre-line text-center md:text-left" style={{
                lineHeight: '1.6'
              }} data-id="element-355">
                  {'Lo que necesitas: \n- Orden, limpieza y cumplimiento. \n- Que alguien se encargue del proceso y sea lo m\xE1s c\xF3modo posible para ti.'}
                </p>
              </div>
            </div>

            <div className="text-center" data-id="element-356">
              <button onClick={scrollToOffer} className="w-full md:w-auto bg-[#E8621A] text-white px-8 md:px-12 py-4 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-all min-h-[52px]" style={{
              lineHeight: '1',
              letterSpacing: '0.08em'
            }} data-id="element-357">
                {renovarCasaSection.ctaText}
              </button>
            </div>
          </div>

          {/* SECCIÓN 3: Inmueble para Arrendar */}
          <div className="max-w-3xl mx-auto space-y-6 md:space-y-8" data-id="element-358">
            <div className="text-center" data-id="element-359">
              <h3 className="text-[20px] md:text-[28px] font-semibold text-white mb-4 md:mb-6" style={{
              lineHeight: '1.3'
            }} data-id="element-360">
                {'\uD83D\uDCB0 \xBFQuieres rentar mejor?'}
              </h3>
            </div>

            <div className="bg-white/5 rounded-3xl p-6 md:p-8 border border-white/10 space-y-6" data-id="element-361">
              <p className="text-[15px] md:text-[17px] text-white/80 font-normal text-center" style={{
              lineHeight: '1.6'
            }} data-id="element-362">
                {'Buscar actualizar tu inmueble para que destaque y lo puedas arrendar a un mejor precio.'}
              </p>
              <div className="bg-[#E8621A]/10 border-2 border-[#E8621A] rounded-2xl p-6" data-id="element-363">
                <p className="text-[15px] md:text-[17px] text-white font-normal text-center md:text-left" style={{
                lineHeight: '1.6'
              }} data-id="element-364">
                  {'Lo que necesitas: Una remodelaci\xF3n inteligente para subir el valor del arriendo sin gastar de m\xE1s.'}
                </p>
              </div>
            </div>

            <div className="text-center" data-id="element-365">
              <button onClick={scrollToOffer} className="w-full md:w-auto bg-[#E8621A] text-white px-8 md:px-12 py-4 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-all min-h-[52px]" style={{
              lineHeight: '1',
              letterSpacing: '0.08em'
            }} data-id="element-366">
                {inmuebleArriendoSection.ctaText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}